'use strict';

export default class ModalStore {

    constructor() {
        this.bindActions(this.alt.getActions('modals'));
        this.openModal = false;
        this.data = false;
        this.selectedItemId = false;
        this.modalInModal = false;
        this.loading = false;
    }

    onCloseModals() {
        this.openModal = false;
        this.data = false;

        if (this.modalInModal) {
            let itemId = this.modalInModal;
            this.modalInModal = false;
            setTimeout( () => {
                this.alt.getActions('media').openCurrentMedia( itemId );
            }, 10 );
        }
    }

    onOpenModal(modal) {
        this.openModal = modal;
        this.data = false;
    }

    onActivateLoading() {
        this.loading = true;
    }
    onDisableLoading() {
        this.loading = false;
    }

    onOpenMediaModal(media) {
        this.data = media;
        this.openModal = 'Media';
    }

    onConfirmModal(data) {
        this.openModal = 'Confirm';
        this.data = data;
    }

    onOpenInstantDownloadModal(media) {
        this.data = media;
        this.openModal = 'InstantDownload';
    }

    onOpenInstantDownloadAllModal(media) {
        this.data = media;
        this.openModal = 'InstantDownloadAll';
    }

    onOpenWatermarkModal(media) {
        this.data = media;
        this.openModal = 'Watermark';
    }

    onOpenExcelSearchModal(data) {
        this.data = data;
        this.openModal = 'ExcelSearch';
    }

    setSelectedItemId(selectedItemId){
        this.selectedItemId = selectedItemId;
    }

    onToggleDownload(fileKey) {
        var item = this.data;

        var files = item.get('files').map( (file) => {
            var key = file.get('key');

            if ( key !== fileKey ) {
                return file;
            }
            file = file.set('_selected', !file.get('_selected'));
            return file;
        });
        this.data = this.data.set( 'files', files );
    }
    
    onToggleDownloadAll(fileKey) {
        this.data = this.data.map((item) => {
            if (item.get('id') == this.selectedItemId) {
                let files = item.get('files').map((file) => {
                    if (file.get('key') === fileKey) {
                          return file.set('_selected', !file.get('_selected'));
                      }
                      return file;
                  });
                  return item.set('files', files);
            }
            return item;
        });
    }

    onSetSelectedForFileKey(params) {
        let fileKey = params[0];
        let checked = params[1];
        this.data = this.data.map((item) => {
                let files = item.get('files').map((file) => {
                    if (file.get('key') == fileKey) {
                          return file.set('_selected', checked);
                      }
                      return file;
                  });
                  return item.set('files', files);
        });
    }

    setModalInModal( id ) {
        this.modalInModal = id;
    }

    static getSelectedInstantDownloadItems() {
        if ( !this.state.data ) {
            return [];
        }

        var selectedItems = [...this.state.data.get('files').toJS()];
        return selectedItems.filter( file => !!file._selected );
    }
}



// WEBPACK FOOTER //
// ./app/stores/modalStore.js